import { StyleSheet } from 'react-native';
import { colors } from '../../shared/theme/colors'
import { spacing } from '../../shared/theme/spacing'
import { typography } from '../../shared/theme/typography'
import { ticketColors } from '../../shared/theme/ticketColors';

export const customerMovementModalStyles = StyleSheet.create({
  fullBackdrop: {
    flex: 1,
    backgroundColor: ticketColors.dim,
    justifyContent: 'flex-end',
  },
  keyboardWrap: {
    width: '100%',
    // Acota el KAV al backdrop: sin esto el maxHeight % del sheet no resuelve en web
    maxHeight: '100%',
    justifyContent: 'flex-end',
  },
  fullCard: {
    width: '100%',
    maxHeight: '96%',
    backgroundColor: ticketColors.paper,
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    borderTopWidth: 1,
    borderColor: ticketColors.ruleSoft,
    paddingTop: 8,
    paddingHorizontal: 20,
    paddingBottom: spacing.sm,
    overflow: 'hidden',
    zIndex: 1,
  },
  grabber: {
    width: 36,
    height: 4,
    borderRadius: 2,
    backgroundColor: ticketColors.rule,
    alignSelf: 'center',
    marginTop: 8,
    marginBottom: 16,
  },
  contentScroll: {
    flexShrink: 1,
  },
  contentScrollContent: {
    paddingBottom: spacing.lg,
    gap: spacing.lg,
  },
  movementsSectionHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: spacing.md,
    marginBottom: spacing.xs,
    paddingTop: spacing.md,
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: ticketColors.rule,
  },
  movementsListWrap: {
    maxHeight: 200,
  },
  movementsList: {
    flex: 1,
  },
  emptyMovements: {
    paddingVertical: spacing.lg,
    alignItems: 'center',
  },
  inputRow: {
    flexDirection: 'row',
    gap: spacing.sm,
    marginTop: spacing.xs,
  },
  fieldRow: {
    flexDirection: 'row',
    gap: spacing.sm,
  },
  formBody: {
    gap: spacing.md,
  },
  fieldCol: {
    flex: 1,
    minWidth: 0,
  },
  inputAmount: {
    minWidth: 120,
    flex: 0,
  },
  inputNote: {
    flex: 1,
    minWidth: 0,
  },
  inputInvalid: {
    borderColor: colors.danger,
  },
  fieldError: {
    ...typography.caption,
    color: colors.danger,
    marginTop: spacing.xs,
  },
  actionHint: {
    ...typography.caption,
    color: ticketColors.ink3,
    marginTop: spacing.xs,
    textAlign: 'center',
  },
  saleLinkRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.sm,
  },
  saleLinkSelector: {
    flex: 1,
    minWidth: 0,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing.sm,
  },
  saleLinkStatic: {
    opacity: 0.92,
  },
  saleLinkLoader: {
    marginTop: spacing.xs,
  },
  saleLinkClear: {
    marginLeft: spacing.xs,
    minWidth: 44,
    minHeight: 44,
    alignItems: 'center',
    justifyContent: 'center',
  },
  attachmentChipRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.sm,
    marginTop: spacing.xs,
    paddingVertical: spacing.xs,
    paddingHorizontal: spacing.sm,
    borderRadius: 10,
    backgroundColor: ticketColors.paper,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
  },
  attachmentChipName: {
    ...typography.caption,
    color: ticketColors.ink,
    flex: 1,
    minWidth: 0,
  },
  attachmentChipRemove: {
    minWidth: 44,
    minHeight: 44,
    alignItems: 'center',
    justifyContent: 'center',
  },
  saleLinkInfoRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.xs,
    marginTop: spacing.xs,
  },
  saleLinkInfoText: {
    color: ticketColors.ink2,
  },
  mixedDebtHintPanel: {
    marginTop: spacing.xs,
  },
  mixedDebtHintHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.xs,
    marginBottom: spacing.xs,
  },
  mixedDebtHintTitle: {
    ...typography.caption,
    color: ticketColors.ink,
    fontWeight: '700',
    flex: 1,
  },
  mixedDebtHintLine: {
    color: ticketColors.ink2,
    marginTop: 2,
  },
  movementRowContent: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: spacing.sm,
  },
  movementRowLeft: {
    flex: 1,
  },
  movementRowRight: {
    alignItems: 'flex-end',
  },
  modeSwitch: {
    flexDirection: 'row',
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper2,
    overflow: 'hidden',
  },
  modeSegment: {
    flex: 1,
    minHeight: 44,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: spacing.sm,
    borderRightWidth: StyleSheet.hairlineWidth,
    borderRightColor: ticketColors.rule,
  },
  modeSegmentLast: {
    borderRightWidth: 0,
  },
  modeSegmentActive: {
    backgroundColor: ticketColors.brandSoft,
    borderBottomWidth: 2,
    borderBottomColor: ticketColors.gold,
  },
  modeSegmentText: {
    ...typography.caption,
    color: ticketColors.ink2,
    fontWeight: '600',
  },
  modeSegmentTextActive: {
    color: ticketColors.gold,
    fontWeight: '700',
  },
  modeSegmentDisabled: {
    opacity: 0.45,
  },
  modeSegmentTextDisabled: {
    color: ticketColors.ink3,
  },
  checkDraftCard: {
    gap: spacing.xs,
    marginBottom: spacing.xs,
    padding: spacing.sm,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper2,
  },
  checkDraftHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  checkDraftTitle: {
    ...typography.caption,
    color: ticketColors.ink,
    fontWeight: '700',
  },
  addCheckBtn: {
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'flex-start',
    gap: 6,
    paddingVertical: spacing.xs,
    minHeight: 44,
  },
  addCheckBtnText: {
    ...typography.caption,
    color: ticketColors.gold,
    fontWeight: '700',
  },
  checkSumError: {
    color: ticketColors.bad,
  },
  chargeInfoHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.xs,
    marginBottom: spacing.xs,
  },
  chargeInfoTitle: {
    ...typography.caption,
    color: ticketColors.ink,
    fontWeight: '700',
  },
  chargeInfoText: {
    color: ticketColors.ink2,
  },
});
